import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { Form, Formik } from 'formik';

import CustomInput from '../CustomInput';
import { GoSearch } from 'react-icons/go';

import './search-bar.scss';

const SearchBar = ({
  showSearch,
  setShowSearch,
  isFocused,
  setIsFocused,
  ...props
}) => {
  const history = useHistory();
  useEffect(() => {
    isFocused &&
      document.querySelector('.main__search__form__field__input').focus();
  });

  function hidePopupWithEsc (e) {
    e.keyCode === 27 && closePopup(false);
  }

  function closePopup () {
    setShowSearch(false);
    setIsFocused(false);
  }

  useEffect(() => {
    window.addEventListener('keyup', hidePopupWithEsc);
    return () => window.removeEventListener('keyup', hidePopupWithEsc);
  }, []);
  return (
    <>
      <div className='main__search show'>
        <Formik
          initialValues={{
            headerSearchKeyword: '',
          }}
          onSubmit={(e, { resetForm }) => {
            history.push(
              `/search?page=${1}&limit=${5}&search=${e.headerSearchKeyword}`
            );
            closePopup();
            setTimeout(() => resetForm(), 1500);
          }}
        >
          {({ values, submitForm }) => (
            <>
              <Form
                className={`main__search__form ${showSearch ? 'show' : ''}`}
              >
                <CustomInput
                  name='headerSearchKeyword'
                  label='Search'
                  fieldStylesClass='main__search__form__field'
                  labelStylesClass='main__search__form__field__label'
                  inputStylesClass='main__search__form__field__input '
                  errorStylesClass='main__search__form__field__error'
                  value={values.headerSearchKeyword}
                  id='topSearchBar'
                />
              </Form>

              <label
                htmlFor={`${
                  history.location.pathname.match(/search/gi)
                    ? 'searchPageInput'
                    : 'topSearchBar'
                }`}
                className='main__search__form__submit'
                onClick={() => {
                  if (history.location.pathname.match(/search/gi)) {
                    window.scroll({
                      top: 100,
                      left: 0,
                      behavior: 'smooth',
                    });
                    document
                      .querySelector('.search__form__field__input')
                      .focus();
                    return;
                  }
                  if (values.headerSearchKeyword !== '' && showSearch) {
                    submitForm();
                    closePopup();
                  } else {
                    setIsFocused(true);
                    setShowSearch(true);
                  }
                }}
              >
                <GoSearch />
              </label>
            </>
          )}
        </Formik>
      </div>
    </>
  );
};

SearchBar.propTypes = {
  showSearch: PropTypes.bool,
  setShowSearch: PropTypes.func,
  isFocused: PropTypes.bool,
  setIsFocused: PropTypes.func,
};
export default SearchBar;
